import PropTypes from "prop-types";

import TextFieldPreview from "@/components/Elements/FieldPreview/TextFieldPreview";
import { useGetObservationComponent } from "@/entities/observation";

export const TableCellComponent = ({ observation }) => {
  const { component, isLoading } = useGetObservationComponent(observation);

  return <TextFieldPreview value={component} loading={isLoading} ellipsis />;
};

TableCellComponent.propTypes = {
  observation: PropTypes.object.isRequired,
};
